module.exports = __webpack_public_path__ + "static/media/status_1.a8f5296f.svg";